import { Typography } from "@mui/material";
import { ParticipantData } from "../interface/bookingOverviewInterface";
import React from "react";
import NoAppointmentsMessage from "./noAppointmentsMessage";
import renderAppointments from "./renderAppointments";

const AppointmentList = ({
  participant,
}: {
  participant: ParticipantData;
}): React.JSX.Element => {
  return (
    <React.Fragment>
      <Typography
        sx={{
          fontWeight: "bold",
          borderBottom: "1px solid",
        }}
        variant="h6"
        component="h6"
      >
        Termine
      </Typography>

      {participant.appointments.data.length === 0 ? (
        <NoAppointmentsMessage />
      ) : (
        renderAppointments({
          participant,
        })
      )}
    </React.Fragment>
  );
};

export default AppointmentList;
